// Browser-safe white-label branding for the shared client runtime.
//
// `__APP_SERVER_NAME__` is inlined at build time by the consuming app's bundler
// (see the Vite `define` in apps/web/vite.config.ts). When no override is
// configured — or in build contexts that don't set the define (e.g. mobile) —
// it falls back to the default server name.
declare const __APP_SERVER_NAME__: string | undefined;

const DEFAULT_APP_BASE_NAME = "T3 Code";
const DEFAULT_APP_SERVER_NAME = `${DEFAULT_APP_BASE_NAME} Server`;

export const APP_SERVER_NAME =
  typeof __APP_SERVER_NAME__ === "string" ? __APP_SERVER_NAME__ : DEFAULT_APP_SERVER_NAME;
